export default __webpack_public_path__ + "static/media/2.Snow_White.f296c0a1.wav";